import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
/*
=============== 
Variables
===============
*/
:root {
  --border: 1px solid var(--bs-primary);
  --transition: all 0.3s linear;
  --nav-height: 55px;
  --min-footer-height: 11vh;
  --card-height: 22rem;
  --primary-blue: #569cd6;
  --primary-light-blue: #a5d6ff;
  --primary-green: #4ec9b0;
  --primary-orange: #f08f69;
  --primary-yellow: #f1e170;
}

/*
=============== 
Global Styles
===============
*/
main {
  min-height: calc(100vh - 2 * var(--nav-height) - 2rem);
}

section {
  margin: 1rem 0;
}

.section {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: var(--nav-height) 0;
}

a:hover {
  cursor: pointer;
}

.title {
  font-family: "Monaspace Krypton SemiBoldItalic", monospace;
  text-transform: uppercase;
}

.text-font-regular {
  font-family: "Monaspace Neon Regular", monospace;
}
.text-font-semibold {
  font-family: "Monaspace Neon SemiBold", monospace;
}
.text-font-italic {
  font-family: "Monaspace Krypton SemiBoldItalic", monospace;
}

.link-icons {
  line-height: 0;
  font-size: 2.25rem;
  margin: 0 1rem;
  color: ${({ theme }) =>
    theme.name === "light" ? "var(--bs-dark)" : "var(--bs-light)"};

  &:hover {
    color: var(--bs-primary);
  }
}

.page-item.active .page-link {
  background-color: var(--bs-primary);
  border-color: var(--bs-primary);
}

.navbar-expand-xl .navbar-nav .nav-link {
  padding: 0rem 1rem;
}

@media screen and (min-width: 800px) {
  .link-icons {
    font-size: 2.5rem;
  }
  .form-group {
      max-width: 750px;
    }
}

@media screen and (min-width: 1367px) {
  .link-icons:hover {
    color: var(--bs-primary);
  }
  }
`;

export default GlobalStyles;
